import { defineMessages, useIntl } from 'react-intl';

import { NotificationVariant, useSnackbarContext } from '@jsmdg/yoshi';
import { type CartError } from '../errors/cartError';
import { ErrorTypes } from '../errors/errorTypes';

const messages = defineMessages({
    genericServerError: {
        defaultMessage:
            'Es ist ein Fehler aufgetreten. Bitte versuche es erneut oder wähle eine andere Zahlungsmethode.',
    },
    inputValidationError: {
        defaultMessage:
            'Sorry, da stimmt etwas mit deinen PayPal-Daten nicht. Bitte gib deine Bestelldaten im nächsten Schritt nochmal ein.',
    },
});

function usePayPalExpressError(): (error: CartError) => void {
    const intl = useIntl();
    const { openSnackbar } = useSnackbarContext();

    return (error: CartError) => {
        const message =
            error.name === ErrorTypes.INPUT_VALIDATION_ERROR
                ? intl.formatMessage(messages.inputValidationError)
                : intl.formatMessage(messages.genericServerError);

        openSnackbar({
            content: message,
            variant: NotificationVariant.Error,
            a11yTextCloseButton: intl.formatMessage({ defaultMessage: 'Schließen' }),
        });
    };
}

export { usePayPalExpressError };
